import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import {
         findTask,
         printTaskList,
         // printTaskTree,
         findSiblingTasks
       } from './taskListHelper'

export function insertTask(projectId, topTaskList, task) {
  let parentTask = findTask(topTaskList, task.parentTaskId)
  let siblingTasks = parentTask === null ? topTaskList : parentTask.taskList
  printTaskList('insertTask', siblingTasks)

  if (siblingTasks) {
    if (!task.precedingTaskId) {
      siblingTasks.unshift(task)
    }
    else {
      const index = siblingTasks.findIndex(siblingTask => siblingTask.taskId === task.precedingTaskId)
      siblingTasks.splice(index+1, 0, task)
    }
  }
  else if (parentTask) {
    parentTask.taskList = [task]
  }

  let newTopTaskList = copyTaskList(topTaskList)
  CacheManager.setObject(CacheKeys.TaskTree(projectId), { taskList: newTopTaskList })
}

export function removeTask(projectId, topTaskList, task) {
  let siblingTasks = findSiblingTasks(topTaskList, task)
  if (!siblingTasks) { // task was deleted from tree when subtree was deleted
    return
  }
  const index = siblingTasks.findIndex(siblingTask => siblingTask.taskId === task.taskId)
  siblingTasks.splice(index, 1)
  console.log('removeTask', siblingTasks);

  let newTopTaskList = copyTaskList(topTaskList)
  CacheManager.setObject(CacheKeys.TaskTree(projectId), { taskList: newTopTaskList })
}

export function replaceTask(topTaskList, oldTaskId, newTask) {
  let oldTask = findTask(topTaskList, oldTaskId)

  // can happen when UI is out of sync with backend
  if (!oldTask)
    return false

  newTask.taskList = oldTask.taskList
  newTask.filtered = oldTask.filtered

  let siblingTasks = findSiblingTasks(topTaskList, oldTask)
  const index = siblingTasks.findIndex(oldTask => oldTask.taskId === oldTaskId)
  siblingTasks[index] = newTask

  let newTopTaskList = copyTaskList(topTaskList)
  CacheManager.setObject(CacheKeys.TaskTree(newTask.projectId), { taskList: newTopTaskList })
  return true
}

// this.state.taskList is being passed, but JSON.stringify failing with error:
// Unhandled Rejection (TypeError): Converting circular structure to JSON
//    --> starting at object with constructor 'HTMLDivElement'
// react is adding _element to the state which looks like cannot be jsonified.
// Hence need to copy into fresh object
function copyTaskList(taskList) {
  let newTaskListStr = JSON.stringify(taskList, function(key, value) {
    if (key === '_element') {
      return;
    }
    return value;
  });
  let newTaskList = JSON.parse(newTaskListStr)
  return newTaskList
}
